export default [
    {
        title: 'Пользователи',
        icon: 'UserIcon',
        route: 'users-user-list',
        action: 'read',
        resource: 'user',
    },
]
